import { render, staticRenderFns } from "./FormInputTextarea.vue?vue&type=template&id=5aeb07b6&"
import script from "./FormInputTextarea.vue?vue&type=script&lang=js&"
export * from "./FormInputTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aeb07b6')) {
      api.createRecord('5aeb07b6', component.options)
    } else {
      api.reload('5aeb07b6', component.options)
    }
    module.hot.accept("./FormInputTextarea.vue?vue&type=template&id=5aeb07b6&", function () {
      api.rerender('5aeb07b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwg/js/components/FormInputTextarea.vue"
export default component.exports